import { render, staticRenderFns } from "./CommentAccountOutline.vue?vue&type=template&id=12465ad0"
import script from "./CommentAccountOutline.vue?vue&type=script&lang=js"
export * from "./CommentAccountOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports